import { Box, Card, CardContent, Stack, Typography } from "@mui/material"

export function InventoryCard({ children, sx, contentSx, isSynced = true }) {
    return (
        <Card sx={sx} data-cy="inventory-card">
            <CardContent sx={{ pb: 0, ...contentSx }}>
                <Stack spacing={2}>
                    {!isSynced && (
                        <Box>
                            <Typography variant="subtitle1">Inventory Quantity</Typography>
                        </Box>
                    )}
                    {children}
                </Stack>
            </CardContent>
        </Card>
    )
}
